export const faqData = [
    {
        title: "What is Suddenly Unicorns?",
        content: `<p> Suddenly Unicorns is an NFT project with <strong>11111</strong> unique Unicorns on the Ethereum blockchain, compliant with <a target="_blank" href="https://ethereum.org/en/developers/docs/standards/tokens/erc-721/" rel="noreferrer noopener">the ERC721 standard</a>.</p>`,
    },
    {
        title: "What is the mint price?",
        content: `<p>The mint price is ${process.env.REACT_APP_TOKEN_PRICE} ETH for each Unicorn + GAS.</p>`,
    },
    {
        title: "Where can I mint?",
        content: `<p>You can mint on this website, <a href="https://www.suddenlyunicorns.com/#mint">www.suddenlyunicorns.com/#mint</a>.</p>`,
    },
    {
        title: "How can I mint NFTs on a desktop device?",
        content: `<p>You will need Metamask plugin for minting. You can connect with the Metamask plugin and mint your NFTs using the minting form on the site.</p>`,
    },
    {
        title: "How can I mint NFTs on a mobile device?",
        content: `<p className="mobile-mint">You will need Metamask app for minting. After installing the app, click the hamburger menu on the top left, and select 'Browser'. In this built-in browser, you will need to navigate to <a href="https://www.suddenlyunicorns.com/" target="_blank" rel="noreferrer noopener">www.suddenlyunicorns.com/</a> and mint your NFTs using the minting form on the site.</p>`,
    },
    {
        title: "How many NFTs can I mint?",
        content: `<p>You can mint up to 20 NFTs per wallet.</p>`,
    },
    {
        title: "How many NFTs are there?",
        content: `<p>There are 11111 Suddenly Unicorns NFTs.</p>`,
    },
    {
        title: "On which blockchain are the NFTs?",
        content: `<p>Suddenly Unicorns is on the Ethereum Mainnet.</p>`,
    },
    {
        title: "When can I see my Suddenly Unicorns NFT after purchase?",
        content: `<p>NFTs will be revealed on the day of your purchase.</p>`,
    },
    {
        title: "Is there a platform where I can see my token, other than classic marketplaces?",
        content: `<p> Yes, you can view your token details at <a href="https://www.suddenlyunicorns.com/token/1" target="_blank" rel="noreferrer noopener">https://www.suddenlyunicorns.com/token/TOKENIDHERE</a>. (external_url of your metadata) .</p>`
    },
    {
        title: "How do you provide fairness on token distribution?",
        content: `<p>The order of the NFTs is definite pre-mint. The provenance hash will be provided pre-sale, and token metadata contains single hashes of that image. The final hash list will be shared post-mint.</p>`,
    },
    {
        title: "What is Provenance Hash mentioned in the question above?",
        content: `<p><a href="https://medium.com/coinmonks/the-elegance-of-the-nft-provenance-hash-solution-823b39f99473" target="_blank" rel="noreferrer noopener">This great article</a> should clarify it all. But in short, it's a hash of all the combined image hashes (a hashception, if you might). And since the combined hash is in order with the token ID, the order cannot be changed or the hash won't be the same.</p>`,
    },
    {
        title: "Where are you storing the metadata and the images?",
        content: `<a name="malala" href="#malala" className="anchor-target"></a><p>They're already on IPFS, both metadata and the images. But to prevent snipers and protect metadata and the images, they will be temporarily stored on AWS and transferred post-mint. Or after a specific time, TBA.</p>`,
    },
    {
        title: "How can I check my Rarities?",
        content: `<p>You can check them on Opensea for the moment and the final Rarities will be published post-drop.</p>`,
    },
    {
        title: "Are you supporting a charity?",
        content: `<div>
            <p> Yes, 5% of the total balance of this project will be donated to <a href="https://malala.org/" target="_blank" rel="noreferrer noopener">Malala Fund</a>. </p>
        </div>`,
    },
    {
        title: "Who is building this?",
        content: `<p>Let us take you to </span> <a href="#team">the team</a>, just below.</p>`,
    }
];
